<template>
    <div>
        <div class="card-body" style="min-height: 200px">
            <div class="bgloading" v-if="isLoading"><Loader></Loader></div>
            <div class="row" v-else>
                <div id="alertBooktable" class="alertbook">
                    <span id="closebtn" class="closebtn" @click="alertBook()"
                        >&times;</span
                    >
                    <strong>Danger! </strong>
                    <div id="alertbookmsj" style="width: 170px; display: contents"></div>
                </div>

                <div id="pageOne">
                    <div class="text-content">
                        <div>
                            <div class="title" id="cmpname">{{ cmpname }}</div>
                        </div>
                    </div>
                    <div class="text-content">
                        <div class="sTitle">Selecte date and party</div>
                    </div>
                    <div class="spacin"></div>
                    <div class="spacinC"></div>
                    <div class="text-content">
                        <div>
                            <div id="calendarf">
                                <header>
                                    <div class="current-date">
                                        <div class="today">
                                            <div>
                                                {{ month[currentDate.month] }}
                                                <div
                                                    style="
                                                        position: absolute;
                                                        margin: 0px;
                                                        margin-left: 10px;
                                                        display: initial;
                                                        font-family: inherit;
                                                        font-size: inherit;
                                                        line-height: inherit;
                                                    "
                                                >
                                                    <div
                                                        v-if="
                                                            currentDate.month !==
                                                            currentDate.monthlimit
                                                        "
                                                        class="arrow-up"
                                                        @click="monthUp()"
                                                    ></div>
                                                    <div
                                                        v-if="currentDate.month > 0"
                                                        class="arrow-down"
                                                        @click="monthDown()"
                                                    ></div>
                                                </div>
                                            </div>
                                            <!-- <div>
														<div class="arrow-up" @click="monthUp()"></div>
														<div v-if="currentDate.month > 0" class="arrow-down" @click="monthDown()"></div>
													</div> -->
                                            <div
                                                style="
                                                    margin-left: 30px;
                                                    font-weight: 10 !important;
                                                    font-size: 18px;
                                                "
                                            >
                                                {{ currentDate.year }}
                                            </div>
                                        </div>
                                    </div>
                                </header>
                                <div class="weekdays">
                                    <div
                                        class="weekday"
                                        v-for="(weekday, index) in weekdays"
                                        :key="index"
                                    >
                                        {{ weekday }}
                                    </div>
                                </div>
                                <div class="date">
                                    <div
                                        class="day-hidden"
                                        v-for="(n, index) in firstMonthDay - 1"
                                        :key="'prev' + index"
                                    >
                                        <!-- {{ (prevMonthDays +1) - firstMonthDay + n }}  -->
                                    </div>
                                    <div
                                        class="day"
                                        :class="{ active: n === currentDate.date }"
                                        @click="currentDate.date = n"
                                        v-for="(n, index) in currentMonthDays"
                                        :key="'day' + index"
                                    >
                                        {{ n }}
                                    </div>
                                    <div
                                        class="day-hidden"
                                        v-for="(n, index) in 43 -
                                        (currentMonthDays + firstMonthDay)"
                                        :key="'next' + index"
                                    >
                                        <!-- {{ n }}  -->
                                    </div>
                                </div>
                            </div>
                            <div id="calendario" class="calendario">
                                <!-- <select id="mons" @change="cak(1)" class="mons" v-model="mes">
											<option v-for="(i,index) in mons" :key="index" v-bind:value="i">{{ i }}</option>                                  
                                        </select>
										<label id="dma" class="dma">{{anioactual}}</label> -->
                                <!-- <button style="display:none" class="calendarBack" id="calendarBack" @click="calendar('b')"><i class="AngleArrow AngleLeft"></i></button>
                                        <button style="display:none" class="calendarNext" id="calendarNext" @click="calendar('n')"><i class="AngleArrow AngleRight"></i></button> -->
                                <table id="tablez" class="tablez"></table>
                            </div>
                            <input type="hidden" id="dateDay" v-model="dateDay" />
                            <input type="hidden" id="dateMon" v-model="dateMon" />
                            <input type="hidden" id="dateDate" v-model="dateDate" />
                            <input type="hidden" id="dayfirst" v-model="dayfirst" />
                            <input type="hidden" id="semana" value="0" v-model="semana" />
                            <input type="hidden" id="daylast" v-model="daylast" />
                        </div>
                    </div>

                    <div class="flexM-containerParty">
                        <div
                            style="
                                text-align: left;
                                margin: 0px;
                                margin-right: 28px;
                                font-weight: bold;
                                margin-top: 27px;
                                margin-bottom: 5px;
                            "
                        >
                            Number of guests:
                        </div>
                        <div>
                            <button class="partyBack" id="partyBack" @click="partys('a')">
                                <i class="AngleNega AngleAlt"></i>
                            </button>
                        </div>
                        <div>
                            <input
                                type="text"
                                v-model="party"
                                id="party"
                                value="1"
                                readonly
                            />
                        </div>
                        <div>
                            <button class="partyNext" id="partyNext" @click="partys('b')">
                                <i class="AnglePlus AngleAlt"></i>
                            </button>
                        </div>
                    </div>
                    <div class="flexM-containerParty">
                        <div
                            style="
                                text-align: left;
                                margin: 0px;
                                margin-right: 120px;
                                font-weight: bold;
                                margin-top: 20px;
                                margin-bottom: 5px;
                            "
                        >
                            Preferred Time:
                        </div>
                        <div>
                            <select name="time" id="time" @change="cak(0)" v-model="time">
                                <option selected>{{ time }}</option>
                                <option
                                    v-for="(i, index) in times"
                                    :key="index"
                                    v-bind:value="i"
                                >
                                    {{ i }}
                                </option>
                            </select>
                        </div>
                    </div>
                    <div class="text-content">
                        <div>
                            <button @click="pageN()">Continue</button>
                        </div>
                    </div>
                </div>

                <div id="pageTwo" style="display: none">
                    <div class="text-content">
                        <div>
                            <div class="title">Your reservation</div>
                        </div>
                    </div>
                    <div class="text-content">
                        <div class="sTitle">Summary</div>
                    </div>
                    <div class="spacin"></div>
                    <div class="text-contents">
                        <div>
                            <div class="dayz" id="dayz">{{ diaactual }}</div>
                            <div class="mon" id="mon">{{ mesactual }}</div>
                        </div>
                        <div>
                            <div class="cmpname" id="cmpname">{{ cmpname }}</div>
                            <div class="dates" id="dates">{{ dates }}</div>
                        </div>
                    </div>

                    <div class="spacinC"></div>

                    <div class="text-content">
                        <div class="info">Contact Info</div>
                    </div>
                    <div class="text-contents">
                        <div>
                            <input
                                type="text"
                                placeholder="First Name"
                                id="firstname"
                                v-model="firstname"
                                required
                            />
                        </div>
                        <div>
                            <input
                                type="text"
                                placeholder="Last Name"
                                id="lastname"
                                v-model="lastname"
                                required
                            />
                        </div>
                    </div>

                    <div class="text-content">
                        <div>
                            <input
                                type="text"
                                placeholder="Phone Number"
                                id="phone"
                                v-model="phone"
                                required
                            />
                        </div>
                    </div>

                    <div class="text-content">
                        <div>
                            <input
                                type="text"
                                placeholder="Email"
                                id="email"
                                v-model="email"
                                required
                            />
                        </div>
                    </div>

                    <div class="text-content">
                        <div>
                            <textarea
                                rows="4"
                                placeholder="Add special resquest (optional)"
                                v-model="note"
                                id="note"
                            ></textarea>
                        </div>
                    </div>

                    <div class="flexM-container">
                        <div>
                            <button @click="pageNB()">Back</button>
                        </div>
                        <div>
                            <button @click="pageT()">Resquest</button>
                        </div>
                    </div>
                </div>

                <div id="pageThree" style="display: none">
                    <div class="title" style="">Reservation Confirmed</div>
                    <div class="confir" style="">Confirmation email sent to</div>
                    <div class="infoE" id="emails">demo@gmail.com</div>
                    <div class="flexM-container">
                        <div>
                            <button @click="pageDone()">Done</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
import Loader from "@/components/shared/Loader.vue";
export default {
    name: "reserForm",
    props: {
        item: { type: Object, required: true },
    },
    components: {
        Loader,
    },
    data () {
        return {
            weekdays: ["Mo", "Tu", "We", "Th", "Fr", "Sa", "Su"],
            weekdayNames: [
                "Sunday",
                "Monday",
                "Tuesday",
                "Wednesday",
                "Thursday",
                "Friday",
                "Saturday",
            ],
            month: [
                "January",
                "February",
                "March",
                "April",
                "May",
                "June",
                "July",
                "August",
                "September",
                "October",
                "November",
                "December",
            ],
            currentDate: {
                date: 0,
                month: 0,
                monthlimit: 0,
                year: 0,
            },

            masterData: [],
            dateTemp: 0,
            diasDelMes: 0,
            num: 1,
            isLoading: false,
            diaMes: [],
            mons: [],
            f: {
                org_id: window.localuserdata,
                user_id: window.localAccountID,
                id: 0,
            },
            party: 1,
            diaactual: 0,
            mesactual: 0,
            anioactual: 0,
            dateDay: 0,
            dateMon: 0,
            dateDate: 0,
            dayfirst: 0,
            semana: 0,
            daylast: 0,
            time: "07:00AM",
            times: [],
            dates: 0,
            mes: "",
            fhours: [],
            cmpname: "",
            firstname: "",
            lastname: "",
            phone: "",
            email: "",
            note: "",
            saldo: 1,
        }
    },
    created () {
        this.getData();
        // this.monst();
        this.getCurrentDate();
    },
    methods: {
        getCurrentDate() {
            let today = new Date();
            this.currentDate.date = today.getDate();
            this.currentDate.month = today.getMonth();
            this.currentDate.monthlimit = today.getMonth() + 1;
            this.currentDate.year = today.getFullYear();
            // console.log(this.currentDate.date)
            // console.log(this.currentDate.month)
            // console.log(this.currentDate.year)
            // let r = this.nolaboral(this.currentDate.date,this.currentDate.month,this.currentDate.year)
            // console.log(r)
        },
        dateUp() {
            if (this.currentDate.date === this.currentMonthDays) {
                this.currentDate.date = 1;
                this.monthUp();
            } else {
                this.currentDate.date += 1;
            }
        },
        dateDown() {
            if (this.currentDate.date === 1) {
                this.currentDate.date = this.prevMonthDays;
                this.monthDown();
            } else {
                this.currentDate.date -= 1;
            }
        },
        monthUp() {
            if (this.currentDate.month === 11) {
                this.currentDate.month = 0;
                this.currentDate.year += 1;
            } else {
                this.currentDate.month += 1;
            }
        },
        monthDown() {
            if (this.currentDate.month === 0) {
                this.currentDate.month = 11;
                this.currentDate.year -= 1;
            } else {
                this.currentDate.month -= 1;
            }
        },

        nolaboral(diaactual, mesactual, anioactual) {
            let r = this.fhours;
            let dias = this.selectDate("es");
            let c = this.numberday(diaactual, mesactual, anioactual);
            let m = dias[0][c];
            let hora = r.dataDimenuHours;
            for (let i in hora) {
                if (hora[i].day.toUpperCase() === m) {
                    if (hora[i].status.toUpperCase() === "CLOSED") {
                        return false;
                    } else {
                        return true;
                    }
                }
            }
        },
        selectDate(a) {
            let dias = [];
            let mes = [];
            if (a === "es") {
                dias = [
                    "LUNES",
                    "MARTES",
                    "MIÉRCOLES",
                    "JUEVES",
                    "VIERNES",
                    "SÁBADO",
                    "DOMINGO",
                ];
                mes = [
                    "ENERO",
                    "FEBRERO",
                    "MARZO",
                    "ABRIL",
                    "MAYO",
                    "JUNIO",
                    "JULIO",
                    "AGOSTO",
                    "SEPTIEMBRE",
                    "OCTUBRE",
                    "NOVIEMBRE",
                    "DICIEMBRE",
                ];
            } else {
                dias = [
                    "MONDAY",
                    "TUESDAY",
                    "WEDNESDAY",
                    "THURSDAY",
                    "FRIDAY",
                    "SATURDAY",
                    "SUNDAY",
                ];
                mes = [
                    "JANUARY",
                    "FEBRUARY",
                    "MARCH",
                    "APRIL",
                    "MAY",
                    "JUNE",
                    "JULY",
                    "AUGUST",
                    "SEPTEMBER",
                    "OCTOBER",
                    "NOVEMBER",
                    "DECEMBER",
                ];
            }
            let diasS = [];
            let mesS = [];
            for (const i in dias) {
                let c = dias[i].charAt(0).toUpperCase() + dias[i].slice(1).toLowerCase();
                let res = c.substring(0, 2);
                diasS.push(res);

                let cmes = mes[i].charAt(0).toUpperCase() + mes[i].slice(1).toLowerCase();
                let resmes = cmes.substring(0, 2);
                mesS.push(resmes);
            }
            let data = [dias, mes, diasS, mesS];
            this.masterData = data;
            return data;
        },
        numberday(diaactual, mesactual, anioactual) {
            let k, o, fechaComoCadena, numeroDia, c;
            if (diaactual > 9) {
                k = diaactual;
            } else {
                k = "0" + diaactual;
            }
            if (mesactual > 9) {
                o = mesactual;
            } else {
                o = "0" + mesactual;
            }
            fechaComoCadena = anioactual + "-" + o + "-" + k + " 01:00:00"; // día viernes
            numeroDia = new Date(fechaComoCadena).getDay();
            c = numeroDia - 1;
            if (numeroDia === 0) {
                c = 6;
            }
            if (numeroDia === 1) {
                c = 0;
            }
            return c;
        },

        clickDate(d) {
            console.log(d);
            let m = 0;
            let dateMon = document.getElementById("dateMon").value;
            let dm = parseInt(dateMon);
            if (dm > 0 && dm !== undefined) {
                m = dm;
            }
            let dateDay = document.getElementById("dateDay");
            dateDay.value = d;
            let semana = parseInt(document.getElementById("semana").value);
            // this.cal(d,m,semana,true)
        },
        getData() {
            let url = "/menu/data";
            window.master
                .post(url, this.f)
                .then((response) => {
                    //console.log('data ',response.data)
                    this.restInput();
                    this.fhours = response.data.a;
                    this.cmpname = this.fhours.r.name;
                    this.firstname = this.item.firstname;
                    this.lastname = this.item.lastname;
                    this.phone = this.item.phone;
                    this.email = this.item.email;
                    this.note = this.item.note;
                    this.time = this.item.time.trim();
                    this.party = this.item.cant_pers;
                    let a = this.item.dates;
                    let ab = a.split("-");
                    // console.log(parseInt(ab[1]))
                    // console.log(parseInt(ab[2]))
                    // this.cal(undefined,undefined,undefined,false);
                })
                .catch((error) => {});
        },
        cal(dx, m, smna, actual) {
            ////valido el idioma
            let ds = this.selectDate("en");
            var dias = ds[0];
            var mes = ds[1];

            //creamos objeto fecha y calculamos los días que tiene el mes, al usar miFecha.getFullYear() ya tendremos correcto el año bisiesto
            let mesactual, diaactual;
            var d = new Date();
            var anioactual = d.getFullYear();
            if (m === undefined) {
                mesactual = d.getMonth() + 1;
            } else {
                mesactual = m;
            }

            if (dx === undefined) {
                diaactual = d.getDate();
            } else {
                diaactual = dx;
            }

            ////////////////mostrar data en el form
            this.form(dias, mes, diaactual, mesactual, anioactual);

            let miFecha = new Date(anioactual + "/" + mesactual + "/01");
            //console.log('miFecha', miFecha);
            let diasDelMes =
                (Date.UTC(miFecha.getFullYear(), miFecha.getMonth() + 1, 1) -
                    Date.UTC(miFecha.getFullYear(), miFecha.getMonth(), 1)) /
                1000 /
                60 /
                60 /
                24;
            this.diasDelMes = diasDelMes;
            //creamos variables para usarlas como nodos y redimensionamos la tabla
            let table = document.getElementsByTagName("table")[1];
            table.style.lineHeight = "1.1";
            table.style.height = "80px";
            table.style.width = "70%";
            table.style.margin = "0 auto";
            table.style.marginBottom = "10px";
            table.style.marginTop = "10px";
            let tablasx = "";
            tablasx += "<tr><th colspan='7' height='30px'></th></tr>";
            tablasx += "<tr>";
            //creamos los días de la tabla
            for (let i = 0; i < 7; i++) {
                let cv = dias[i].charAt(0).toUpperCase();
                let cvc = dias[i].slice(1).toLowerCase();
                let u = cv + cvc;
                let res = u.substring(0, 2);
                // dtext = document.createTextNode(res);
                tablasx += "<th>" + res + "</th>";
            }
            tablasx += "</tr>";

            //Creamos calendario, num serán los días y dateTemp una fecha temporal para saber por cual día empieza el mes miFecha.getMonth() del año miFecha.getFullYear() (para saber bisiestos)
            var num = 1;
            var dateTemp = new Date(
                miFecha.getFullYear() + "-" + (miFecha.getMonth() + 1) + "-1"
            );
            this.dateTemp = dateTemp;
            //////////////valida y calcula la semana actual
            let conter = this.semanas(actual, smna);

            ////////////// primer y ultimo dia del mes
            let priUlts = this.priUlt(anioactual, mesactual, diaactual);
            let pri = priUlts[0];
            let ult = priUlts[1];

            var op = 1;
            for (let i = 0; i < 6; i++) {
                //////////////muesta el almanaque por semana
                if (op !== conter) {
                    tablasx += "<tr class='noSelect'>";
                } else {
                    tablasx += "<tr>";
                }
                for (let j = 1; j < 8; j++) {
                    if (
                        ((j < dateTemp.getDay() || (dateTemp.getDay() === 0 && j !== 7)) &&
                            i === 0) ||
                        num > diasDelMes
                    ) {
                        tablasx += "<td></td>";
                    } else {
                        let lb = this.nolaboral(num, mesactual, anioactual);
                        if (num === diaactual) {
                            if (lb === true) {
                                tablasx +=
                                    '<td class="Selected" onclick="clickDate(' +
                                    num +
                                    "," +
                                    i +
                                    ')";>';
                            } else {
                                tablasx += "<td class='Selected unselectable'>";
                            }
                        } else {
                            if (lb === true) {
                                tablasx +=
                                    '<td class="Select" onclick="clickDate(' +
                                    num +
                                    ')";>';
                            } else {
                                tablasx += "<td class='Select unselectable'>";
                            }
                        }

                        tablasx += num;
                        tablasx += "</td>";
                        if (pri === num) {
                            this.dayfirst = i + 1;
                        }
                        if (ult === num) {
                            this.daylast = i + 1;
                        }
                        num++;
                    }
                }
                tablasx += "</tr>";
                op++;
            }
            document.getElementById("tablez").innerHTML = tablasx;

            document.styleSheets[0].addRule(".Selected", "background: #028cf1;");
            document.styleSheets[0].addRule(".Selected", "border-radius: 100px;");
            document.styleSheets[0].addRule(".Selected", "padding: 8px;");
            document.styleSheets[0].addRule(".Selected", "color: #fff;");
            document.styleSheets[0].addRule(".Selected", "cursor: pointer;");
            document.styleSheets[0].addRule(
                ".Selected",
                "border: 0px solid rgb(85, 85, 85) !important;"
            );
            document.styleSheets[0].addRule(".Selected:hover", "background: #c3dbef;");
            document.styleSheets[0].addRule(".Selected:hover", "color: blue;");
            document.styleSheets[0].addRule(".Selected:hover", "cursor: pointer;");

            document.styleSheets[0].addRule(".Select", "border-radius: 100px;");
            document.styleSheets[0].addRule(".Select", "padding: 8px;");
            document.styleSheets[0].addRule(".Select", "color: blue;");
            document.styleSheets[0].addRule(".Select", "cursor: pointer;");
            document.styleSheets[0].addRule(
                ".Select",
                "border: 0px solid rgb(85, 85, 85) !important;"
            );
            document.styleSheets[0].addRule(".Select:hover", "background: #c3dbef;");
            document.styleSheets[0].addRule(".Select:hover", "cursor: pointer;");

            document.styleSheets[0].addRule(
                ".Select.unselectable",
                "border-radius: 100px;"
            );
            document.styleSheets[0].addRule(".Select.unselectable", "padding: 8px;");
            document.styleSheets[0].addRule(
                ".Select.unselectable",
                "background-color: #ddd;"
            );
            document.styleSheets[0].addRule(
                ".Select.unselectable",
                "cursor: not-allowed !important;"
            );

            this.selectTime(diaactual, mesactual, anioactual);

            // let came = this.dayfirstlast();
            // let daylast = came[1];
            // if(m === 2 && smna !== undefined){
            //     if(smna > daylast){
            //         let r = smna - 1;
            //         this.semana = r;
            //         smna = r;
            //         this.cal(dx,m,smna,true)
            //    }
            // }
            //this.backnext(came);
        },
        ////////////////////NEXT PAGE
        pageT() {
            let fn = 0;
            let ln = 0;
            let pn = 0;
            let em = 0;
            let tm = 0;
            let cp = 0;
            let dt = 0;

            let firstname = this.firstname;
            let lastname = this.lastname;
            let phone = this.phone;
            let email = this.email;
            let note = this.note;
            let time = this.time;
            let cant_pers = this.party.toString();
            let date = this.dateDate;
            if (firstname.length > 0) {
                fn = firstname;
            }
            if (lastname.length > 0) {
                ln = lastname;
            }
            if (phone.length > 0) {
                pn = phone;
            }
            if (email.length > 0) {
                em = email;
            }
            if (time.length > 0) {
                tm = time;
            }
            if (cant_pers.length > 0) {
                cp = cant_pers;
            }
            if (date.length > 0) {
                dt = date;
            }
            if (
                fn.length > 0 &&
                ln.length > 0 &&
                pn.length > 0 &&
                em.length > 0 &&
                tm.length > 0 &&
                cp.length > 0
            ) {
                document.getElementById("emails").innerHTML = email;
                let data = {
                    org_id: this.fhours.r.org_id,
                    user_id: this.fhours.r.user_id,
                    id: this.item.id,
                    firstname: fn,
                    lastname: ln,
                    phone: pn,
                    email: em,
                    note: note,
                    cant_pers: cp,
                    date: dt,
                    time: tm,
                };
                let url = "/menu/editreserve";
                window.master
                    .post(url, data)
                    .then((response) => {
                        console.log("get ", response.data);
                        let x = document.getElementById("pageTwo");
                        if (x.style.display !== "none") {
                            x.style.display = "none";
                            document.getElementById("pageThree").style.display = "block";
                        }
                        this.restInput();
                    })
                    .catch((error) => {
                        console.error("Error:", error);
                        document.getElementById("alertbookmsj").innerHTML =
                            "Could not be completed the reservation.";
                        let x = document.getElementById("alertBooktable");
                        x.style.display = "block";
                    });
            } else {
                document.getElementById("alertbookmsj").innerHTML =
                    "The fields are empty.";
                let x = document.getElementById("alertBooktable");
                x.style.display = "block";
            }
        },
        alertBook() {
            let x = document.getElementById("alertBooktable");
            x.style.display = "none";
        },
        pageTh() {
            var x = document.getElementById("pageThree");
            if (x.style.display !== "none") {
                x.style.display = "none";
                document.getElementById("pageOne").style.display = "block";
            }
        },
        pageN() {
            var x = document.getElementById("pageOne");
            if (x.style.display !== "none") {
                x.style.display = "none";
                document.getElementById("pageTwo").style.display = "block";
            }
            ////valido el idioma
            let ds = this.selectDate("en");
            var dias = ds[0];
            var mes = ds[1];
            ////////////////mostrar data en el form
            this.form(dias, mes, this.diaactual, this.dateMon, this.anioactual);
        },
        pageNB() {
            var x = document.getElementById("pageTwo");
            if (x.style.display !== "none") {
                x.style.display = "none";
                document.getElementById("pageOne").style.display = "block";
            }
        },
        pageTB() {
            var x = document.getElementById("pageThree");
            if (x.style.display !== "none") {
                x.style.display = "none";
                document.getElementById("pageTwo").style.display = "block";
            }
        },
        pageDone() {
            let x = document.getElementById("pageThree");
            if (x.style.display !== "none") {
                x.style.display = "none";
                document.getElementById("pageOne").style.display = "block";
            }
            this.restInput();
            this.ShowdataItem = false;
            this.$modal.hide("modal_reserve");
            this.$store.commit("set_reserve", true);
        },
        restInput() {
            this.firstname = "";
            this.lastname = "";
            this.phone = "";
            this.email = "";
            this.note = "";
            this.dateDate = "";
            document.getElementById("emails").innerHTML = "";
            this.party = 1;
            this.time = "07:00AM";
        },
        selectTime(diaactual, mesactual, anioactual) {
            let dias = this.selectDate("es");
            let c = this.numberday(diaactual, mesactual, anioactual);
            let m = dias[0][c];
            let r = this.fhours;
            let hora = r.dataDimenuHours;
            let hi = [];
            let ho = [];
            for (let i in hora) {
                if (hora[i].day.toUpperCase() === m) {
                    let a = hora[i].hour_one;
                    let ab = a.split(":");
                    let ha = parseInt(ab[0]);
                    let ma = parseInt(ab[1]);
                    let k,
                        o,
                        am = "AM",
                        pm = "PM",
                        r,
                        s;
                    for (let ih = ha; ih <= 12; ih++) {
                        if (ih <= 9) {
                            k = "0" + ih;
                        } else {
                            k = ih;
                        }
                        for (let im = ma; im <= 59; im++) {
                            if (im <= 9) {
                                o = "0" + im;
                            } else {
                                o = im;
                            }
                            if (ih < 12 && ma <= im) {
                                r = k + ":" + o + am;
                            } else {
                                r = k + ":" + o + pm;
                            }
                            let lo = r.trim();
                            hi.push(lo);
                        }
                    }

                    let b = hora[i].hour_two;
                    let bb = b.split(":");
                    let hb = parseInt(bb[0]);
                    let mb = parseInt(bb[1]);
                    for (let ih = 1; ih <= hb; ih++) {
                        if (ih <= 9) {
                            k = "0" + ih;
                        } else {
                            k = ih;
                        }
                        for (let im = mb; im <= 59; im++) {
                            if (im <= 9) {
                                o = "0" + im;
                            } else {
                                o = im;
                            }
                            if (ih <= hb - 1) {
                                s = k + ":" + o + pm;
                                let yu = s.trim();
                                ho.push(yu);
                            }
                        }
                    }
                }
            }
            let children = hi.concat(ho);
            this.times = children;
        },
        calendar(smana) {
            let m = 0;
            let dateMon = this.dateMon;
            let dm = parseInt(dateMon);
            if (dm > 0 && dm !== undefined) {
                m = dm;
            }
            let d = parseInt(this.dateDay);
            this.cal(d, m, smana, false);
        },
        partys(a) {
            let p = 1;
            let conter = 0;
            let party = parseInt(this.party);
            if (a !== undefined) {
                if (a === "b") {
                    conter = party + p;
                } else {
                    conter = party - p;
                }
                if (conter <= 100 && conter >= 1) {
                    this.party = conter;
                }
            }
        },
        priUlt(anioactual, mesactual, diaactual) {
            let ma, da;
            if (mesactual < 10) {
                ma = "0" + mesactual;
            } else {
                ma = mesactual;
            }
            if (diaactual < 10) {
                da = "0" + diaactual;
            } else {
                da = diaactual;
            }
            let date = new Date(anioactual + "-" + ma + "-" + da);
            let primerDia = new Date(date.getFullYear(), date.getMonth(), 1);
            let ultimoDia = new Date(date.getFullYear(), date.getMonth() + 1, 0);
            let ult = ultimoDia.getDate();
            let pri = primerDia.getDate();
            let data = [pri, ult];
            return data;
        },

        dayfirstlast() {
            let dayfirst = this.dayfirst;
            let daylast = this.daylast;
            let data = [dayfirst, daylast];
            return data;
        },
        semanas(actual, smna) {
            let semana = this.getWeekNumber();
            let Ssemana = 1;
            let conter = 0;
            let pivote = parseInt(semana);
            if (actual === false) {
                if (smna !== undefined) {
                    if (smna === "b") {
                        conter = pivote - Ssemana;
                    } else {
                        conter = pivote + Ssemana;
                    }
                }
                ///////////////se llena por primera vez al cargar
                if (conter === 0) {
                    conter = semana;
                }
            } else {
                conter = smna;
            }
            this.semana = conter;
            return conter;
        },
        form(dias, mes, diaactual, mesactual, anioactual) {
            this.dateDay = diaactual;
            this.dateMon = mesactual;
            this.diaactual = diaactual;
            this.mesactual = mesactual;
            this.anioactual = anioactual;

            let on = mesactual - 1;
            let cv = mes[on].toUpperCase();
            this.mes = cv.charAt(0).toUpperCase() + cv.slice(1).toLowerCase();
            let res = cv.substring(0, 3);
            this.mesactual = res;

            let party = this.party;
            let time = this.time;
            let k, o, fechaComoCadena, numeroDia, c, nombreDia, cs, dates;
            if (diaactual > 9) {
                k = diaactual;
            } else {
                k = "0" + diaactual;
            }
            if (mesactual > 9) {
                o = mesactual;
            } else {
                o = "0" + mesactual;
            }
            fechaComoCadena = anioactual + "-" + o + "-" + k + " 01:00:00"; // día viernes
            numeroDia = new Date(fechaComoCadena).getDay();
            c = numeroDia - 1;
            if (numeroDia === 0) {
                c = 6;
            }
            if (numeroDia === 1) {
                c = 0;
            }

            nombreDia = dias[c].substring(0, 3);
            cs = nombreDia.charAt(0).toUpperCase() + nombreDia.slice(1).toLowerCase();
            dates = cs + " " + time + " Party of " + party;
            this.dates = dates;
            this.dateDate = anioactual + "-" + o + "-" + k;
        },
        getWeekNumber() {
            let now = new Date();
            let onejan = new Date(now.getFullYear(), 0, 1);
            let week = Math.ceil(
                ((now.getTime() - onejan.getTime()) / 86400000 + onejan.getDay() + 1) / 7
            );
            return week;
        },
        cak(a) {
            let d = 0;
            let t = this.dateMon;
            let m;
            if (a > 0) {
                m = parseInt(t) + 1;
            } else {
                m = parseInt(t);
            }
            let dateDay = this.diaactual;
            let dm = parseInt(dateDay);
            if (dm > 0 && dm !== undefined) {
                d = dm;
            }
            let semana = parseInt(this.semana);
            // this.restCalendar();
            this.cal(d, m, semana, true);
        },
        monst() {
            let ds = this.selectDate("en");
            var mes = ds[1];
            let dy = new Date();
            let mact = dy.getMonth() + 1;
            let r = [];
            for (var ji = 0; ji <= mact; ji++) {
                if (mes[ji] !== undefined) {
                    let m = mes[ji];
                    let cv = m.charAt(0).toUpperCase() + m.slice(1).toLowerCase();
                    r.push(cv);
                }
            }
            this.mons = r;
        },

        restCalendar() {
            document.getElementsByTagName("table")[1].remove();
            let table = document.createElement("table");
            table.setAttribute("class", "tablez");
            table.setAttribute("id", "tablez");
            document.getElementById("calendario").appendChild(table);
        },
    },
    computed: {
        ...mapGetters(["get_reserve"]),
        prevMonthDays() {
            let year =
                this.currentDate.month === 0
                    ? this.currentDate.year - 1
                    : this.currentDate.year;
            let month = this.currentDate.month === 0 ? 12 : this.currentDate.month;
            return new Date(year, month, 0).getDate();
        },
        firstMonthDay() {
            let firstDay = new Date(
                this.currentDate.year,
                this.currentDate.month,
                1
            ).getDay();
            if (firstDay === 0) firstDay = 7;
            return firstDay;
        },
        currentDay() {
            return new Date(
                this.currentDate.year,
                this.currentDate.month,
                this.currentDate.date
            ).getDay();
        },
        currentMonthDays() {
            return new Date(
                this.currentDate.year,
                this.currentDate.month + 1,
                0
            ).getDate();
        },
    },
}
</script>
<style lang="scss" scoped>
@mixin calendar-layout($property) {
    display: grid;
    justify-content: center;
    // grid-template-columns: repeat(auto-fit, minmax(50px, 1fr));
    grid-template-columns: repeat(7, 30px);
    grid-gap: 1px;
    padding: 1px 1px 1px;
    div {
        display: flex;
        justify-content: center;
        align-items: center;
        color: #6a7a8c;
        font-family: ProximaNova, sans-serif;
        font-weight: bold;
        font-size: 0.875rem;
        border-radius: 100px;
    }
}
@mixin arrow-style() {
    width: 0;
    height: 0;
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    cursor: pointer;
}
#calendarf {
    background: #f4f4f4;
    overflow: hidden;
    background-size: cover;
    user-select: none;

    header {
        display: flex;
        justify-content: center;
        align-items: top;
        height: 60px;
        padding: 20px 0 0;
        text-align: center;
        overflow: hidden;
        color: #212529;
        .arrow-up {
            @include arrow-style();
            border-bottom: 10px solid #028cf1;
            &:hover {
                border-bottom: 10px solid #c3dbef;
            }
        }
        .arrow-down {
            @include arrow-style();
            border-top: 10px solid #028cf1;
            margin-top: 2px;
            &:hover {
                border-top: 10px solid #c3dbef;
            }
        }
        .today {
            display: flex;
            justify-content: center;
            div {
                justify-content: center;
                margin-right: 30px;
            }
        }
        .today {
            font-size: 14px;
        }
    }
    .weekdays {
        @include calendar-layout(10px 20px 10px);
        div:nth-child(7n) {
            color: #d43541;
        }
    }
    .date {
        @include calendar-layout(10px 20px 20px);
        background: #f4f4f4;
        .active {
            color: #fff !important;
            background: #028cf1;
        }
        .day {
            color: blue;
            font-family: ProximaNova, sans-serif;
            font-size: 0.875rem;
            font-weight: 400;
            line-height: 1.5;
            padding: 5px;
            cursor: pointer;
            &:hover {
                background: #c3dbef;
                color: blue !important;
            }
            &:nth-child(7n) {
                color: #d43541;
                &:hover {
                    background: #c3dbef;
                    color: #d43541;
                }
            }
        }
        .day-hidden {
            opacity: 0.4;
            padding: 5px;
            &:nth-child(7n) {
                color: #d43541;
            }
        }
    }
}

.calendario {
    background: #f4f4f4;
    padding-bottom: 1px;
    padding-top: 1px;
    margin-bottom: 5px;
    margin-top: 5px;
}
.partyBack {
    border-radius: 100px;
}
.flexM-containerParty {
    display: flex;
    flex-wrap: wrap;
}
.flexM-containerParty > div {
    text-align: center;
    line-height: 35px;
    font-size: 14px;
    margin-top: 20px;
    margin-bottom: 5px;
}
.flexM-containerParty > div > button {
    color: blue;
    border-radius: 100px;
    border: 1px #c7c7c7 solid;
}
.flexM-containerParty > div > input {
    color: #1e1d24;
    border: 0px #c7c7c7 solid;
    width: 70px;
    text-align: center;
    font-size: 30px;
    font-weight: bold;
    margin-top: 5px;
}
.flexM-containerParty > div > select {
    width: 100%;
    height: 40px;
    border-radius: 2px;
    border: 1px #c7c7c7 solid;
    padding: 10px;
}
.flexM-container {
    display: flex;
    flex-wrap: wrap;
}
.flexM-container > div {
    width: 100px;
    margin: auto;
    margin-bottom: 8px;
    text-align: center;
    line-height: 35px;
    font-size: 14px;
}
.flexM-container > div > select {
    width: 90%;
    height: 30px;
    float: left;
    border-radius: 2px;
    border: 1px #c7c7c7 solid;
}
.flexM-container > div > button {
    color: blue;
    padding-left: 15px;
    padding-right: 15px;
    border-radius: 5px;
    border: 1px #c7c7c7 solid;
}
.AngleAlt {
    display: inline-block;
    width: 50px;
    height: 50px;
    background: linear-gradient(#fff, #fff), linear-gradient(#fff, #fff), #000;
    background-position: center;
    background-size: 50% 2px, 2px 50%; /*thickness = 2px, length = 50% (25px)*/
    background-repeat: no-repeat;
}
.AnglePlus {
    background: linear-gradient(#028cf1, #028cf1), linear-gradient(#028cf1, #028cf1);
    background-position: center;
    background-size: 50% 2px, 2px 50%; /*thickness = 2px, length = 50% (25px)*/
    background-repeat: no-repeat;
    display: block;
    margin: 0px;
    padding: 0px;
}
.AngleNega {
    background: linear-gradient(#028cf1, #028cf1), linear-gradient(#028cf1, #028cf1);
    background-position: center;
    background-size: 50% 2px, 2px 0%; /*thickness = 2px, length = 50% (25px)*/
    background-repeat: no-repeat;
    display: block;
    margin: 0px;
    padding: 0px;
}
.AngleArrow {
    border: solid black;
    border-width: 0 1px 1px 0;
    display: inline-block;
    padding: 5px;
}
.AngleRight {
    transform: rotate(-45deg);
    -webkit-transform: rotate(-45deg);
}
.AngleLeft {
    transform: rotate(135deg);
    -webkit-transform: rotate(135deg);
}
.calendarBack {
    position: absolute;
    display: block;
    float: left;
    margin-top: 54px;
    margin-left: 7px;
    padding: 10px;
}
.calendarNext {
    position: absolute;
    margin-top: 54px;
    margin-left: 121px;
    padding: 10px;
}
.btnRt {
    border: 1px solid gray;
    border-radius: 5px;
    padding: 8px;
}
.btnRt:hover {
    background-color: #ddd;
}
.alertbook {
    padding: 20px;
    background-color: #f44336;
    color: white;
    opacity: 1;
    transition: opacity 0.6s;
    margin-bottom: 15px;
    display: none;
    position: absolute;
    width: 90%;
    margin-top: 5px;
}
.closebtn {
    margin-left: 15px;
    color: white;
    font-weight: bold;
    float: right;
    font-size: 22px;
    line-height: 20px;
    cursor: pointer;
    transition: 0.3s;
}
.tablez {
    background: #f4f4f4;
}
.noSelect {
    display: none;
}
.Selected {
    background: #028cf1;
    border-radius: 100px;
    padding: 8px;
    color: #fff;
    cursor: pointer;
}
.Selected:hover {
    background: #c3dbef;
    color: blue;
    cursor: pointer;
}
.Selected.unselectable {
    border-radius: 100px;
    padding: 8px;
    background-color: #ddd;
    cursor: not-allowed !important;
}
.Select {
    border-radius: 100px;
    padding: 8px;
    color: blue;
    cursor: pointer;
}
.Select:hover {
    background: #c3dbef;
    cursor: pointer;
}
.Select.unselectable {
    border-radius: 100px;
    padding: 8px;
    background-color: #ddd;
    cursor: not-allowed !important;
}

.spacin {
    border-bottom: 4px solid #ccc;
    border-radius: 10px;
}
.spacinC {
    border-bottom: 1px solid #ccc;
    border-radius: 10px;
}
.title {
    text-align: center;
    margin: auto;
    font-weight: bold;
    font-size: 20px;
    color: black;
}
.titleC {
    font-size: 21px !important;
    line-height: 1 !important;
    font-weight: 0 !important;
}
.sTitle {
    text-align: center;
    font-size: 14px;
    margin-top: -10px;
}
.info {
    text-align: left !important;
    margin-bottom: 0px;
    margin-top: 11px;
    font-size: 12px;
    font-weight: bold;
    color: black;
}
.infoE {
    text-align: center;
    margin-bottom: 20px;
    font-size: 12px;
    font-weight: bold;
    color: black;
}
.dayz {
    text-align: left;
    margin: auto;
    font-weight: bold;
    font-size: 24px;
    margin-left: 10px;
    color: black;
}
.mon {
    text-align: left;
    margin: auto;
    margin-left: 13px;
    font-size: 10px;
    margin-top: -14px;
}
.mons {
    position: absolute;
    margin: 0px auto;
    display: block;
    margin-left: 80px;
    margin-top: 2px;
    border: none;
    background: transparent;
}
.dma {
    position: absolute !important;
    margin-left: 40px !important;
    font-size: 16px;
    font-weight: 10 !important;
}
th {
    font-weight: 10 !important;
}
.text-content {
    display: grid;
}
.text-content > div {
    text-align: center;
}
.text-content > div > input[type="text"],
textarea {
    width: 95%;
    margin-bottom: 3px;
    margin-top: 3px;
    border-radius: 2px;
    border: 1px #c7c7c7 solid;
}
.text-content > div > button {
    background: #028cf1;
    color: white;
    border-radius: 2px;
    border: 0px #c7c7c7 solid;
    width: 100%;
    margin-top: 20px;
    margin-bottom: 5px;
}
.text-content > div > p {
    margin: 0px;
    padding: 0px;
    box-sizing: border-box;
    text-align: left;
    margin-left: 20px;
}
.text-contents {
    display: grid;
    grid-template-columns: auto auto auto;
}
.text-contents > div {
    text-align: center;
}

.text-contents > div > input[type="text"] {
    width: 90%;
    margin-bottom: 3px;
    margin-top: 3px;
    border-radius: 2px;
    border: 1px #c7c7c7 solid;
}

.text-contents > div > p {
    margin: 0px;
    padding: 0px;
    box-sizing: border-box;
    text-align: left;
    margin-left: 10px;
}
.text-contents > div > select {
    width: 90%;
    height: 30px;
    float: left;
    border-radius: 2px;
    border: 1px #c7c7c7 solid;
    margin-top: 7px;
}
.closebtn {
    margin-left: 15px;
    color: white;
    font-weight: bold;
    float: right;
    font-size: 22px;
    line-height: 20px;
    cursor: pointer;
    transition: 0.3s;
}
.alertbook {
    padding: 20px;
    background-color: #f44336;
    color: white;
    opacity: 1;
    transition: opacity 0.6s;
    margin-bottom: 15px;
    display: none;
    position: absolute;
    width: 90%;
    margin-top: 5px;
}
</style>
